import * as React from 'react';
import { createContext, useEffect, useState } from 'react';
import { isProductionSite } from '../utils/metricaEnvironment';
import { useSiteConfig } from './SiteConfigContext';

export const MetricaContext = createContext({
  isProduction: true,
  metricaURL: 'https://metrica.sorpetaler.de:900/Metrica',
});

export const MetricaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { metricaUrl } = useSiteConfig();
  const [isProduction, setIsProduction] = useState(isProductionSite);
  const [isInternal, setIsInternal] = useState(false);

  useEffect(() => {
    const pathname =
      typeof window !== 'undefined' ? window.location.pathname : undefined;
    setIsProduction(isProductionSite(undefined, pathname));
  }, []);

  useEffect(() => {
    if (isProduction) return;

    let cancelled = false;
    import('axios')
      .then(({ default: axios }) =>
        axios.get('https://metrica.sorpetaler.de:888/Metrica/wrapper', {
          timeout: 4000,
        })
      )
      .catch((err) => {
        if (!cancelled && err.code === 'ECONNABORTED') {
          setIsInternal(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [isProduction]);

  const metricaURL = isProduction
    ? metricaUrl || 'https://metrica.sorpetaler.de:900/Metrica'
    : !isInternal
    ? 'https://metrica.sorpetaler.de:888/Metrica'
    : 'http://10.10.23.2:8890/Metrica';

  return (
    <MetricaContext.Provider
      value={{
        isProduction,
        metricaURL,
      }}
    >
      {children}
    </MetricaContext.Provider>
  );
};
